export default "__VITE_ASSET__daf31673__"